import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';

import { authorizationServerUrl } from '../constants/server-settings';
import { OAuth2AuthCodePKCE } from '../custom-lib/oauth2-auth-code-PKCE';

@Injectable()
export class OAuth2Service {
    oAuth2: OAuth2AuthCodePKCE = new OAuth2AuthCodePKCE({
        authorizationUrl: `${environment.authorizationServerUrl}/realms/internet-banking/protocol/openid-connect/auth`,
        tokenUrl: `${environment.authorizationServerUrl}/realms/internet-banking/protocol/openid-connect/token`,
        clientId: 'web',
        scopes: ['profile', 'openid'],
        redirectUrl: `${window.location.origin}/login/`,
        onAccessTokenExpiry(refreshAccessToken) {
            return refreshAccessToken();
        },
        onInvalidGrant(refreshAuthCodeOrRefreshToken) {}
    });

    logout(): void {
        const accessToken = this.oAuth2.getAccessToken();
        if (accessToken) {
            const revokeUrl = `${authorizationServerUrl}/oauth/revoke?token=${accessToken}`;
            fetch(revokeUrl, { method: 'POST' })
                .then(response => {
                    if (response.ok) {
                        localStorage.removeItem('access_token');
                        localStorage.removeItem('refresh_token');
                    } else {
                        console.error('Failed to revoke access token');
                    }
                })
                .catch(error => console.error('Error revoking access token:', error));
        }
    }
}
